import React from "react";

const Loader = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-t-2 border-primary"></div>
    </div>
  );
};

export default Loader;
